import {
  IOperationDetail,
  IOperationListItem,
  IOperationPayload,
  IOperationSaveError,
  IUserIntegrator,
  IUserIntegratorResponse,
  IWebHookConfigHeader,
  IWebHookConfigHeadersPayload,
  IWebServiceConfig,
  IWebServiceConfigPayload,
  IWebServiceSaveError,
  IWebhookEvent,
  IWebhookEventQueryParams
} from '../models/api.model';
import { createAction, props } from '@ngrx/store';

import { ServiceResponse } from '@literax/interfaces/service-response';

export enum EApiActions {
  GetWebServiceConfigIndex = '[Api] Get WebServiceConfig',
  GetWebServiceConfigIndexSuccess = '[Api] Get WebServiceConfig Success',
  GetWebServiceConfigIndexError = '[Api] Get WebServiceConfig Error',

  ShowWebServiceConfig = '[Api] Show WebServiceConfig',
  ShowWebServiceConfigSuccess = '[Api] Show WebServiceConfig Success',
  ShowWebServiceConfigError = '[Api] Show WebServiceConfig Error',

  CreateWebServiceConfig = '[Api] Create WebServiceConfig',
  CreateWebServiceConfiguSuccess = '[Api] Create WebServiceConfig Success',
  CreateWebServiceConfigError = '[Api] Create WebServiceConfig Error',

  UpdateWebServiceConfig = '[Api] Update WebServiceConfig',
  UpdateWebServiceConfigSuccess = '[Api] Update WebServiceConfig Success',
  UpdateWebServiceConfigError = '[Api] Update WebServiceConfig Error',

  DeleteWebServiceConfig = '[Api] Delete WebServiceConfig',
  DeleteWebServiceConfigSuccess = '[Api] Delete WebServiceConfig Success',
  DeleteWebServiceConfigError = '[Api] Delete WebServiceConfig Error',

  GetOperationsIndex = '[Api] Get Operation',
  GetOperationsIndexSuccess = '[Api] Get Operation Success',
  GetOperationsIndexError = '[Api] Get Operation Error',

  ShowOperation = '[Api] Show Operation',
  ShowOperationSuccess = '[Api] Show Operation Success',
  ShowOperationError = '[Api] Show Operation Error',

  CreateOperation = '[Api] Create Operation',
  CreateOperationuSuccess = '[Api] Create Operation Success',
  CreateOperationError = '[Api] Create Operation Error',

  UpdateOperation = '[Api] Update Operation',
  UpdateOperationSuccess = '[Api] Update Operation Success',
  UpdateOperationError = '[Api] Update Operation Error',

  DeleteOperation = '[Api] Delete Operation',
  DeleteOperationSuccess = '[Api] Delete Operation Success',
  DeleteOperationError = '[Api] Delete Operation Error',

  setWebServiceConfigurationsSort = '[Api] Set WebServiceConfigSort',
  setOperationsSort = '[Api] Set OperationsSort',
  setUserIntegratorSort = '[Api] Set UserIntegratorSort',

  ClearSelectedWebService = '[Api] Clear SelectedWebService',
  ClearSelectedOperation = '[Api] Clear SelectedOperation',
  ClearUserSelectedIntegrator = '[Api] Clear SelectedUserIntegrator',

  // CreateUserIntegrator
  CreateUserIntegrator = '[Api] Create UserIntegrator',
  CreateUserIntegratorSuccess = '[Api] Create UserIntegrator Success',
  CreateUserIntegratorError = '[Api] Create UserIntegrator Error',

  ShowUserIntegrator = '[Api] Show UserIntegrator',
  ShowUserIntegratorSuccess = '[Api] Show UserIntegrator Success',
  ShowUserIntegratorError = '[Api] Show UserIntegrator Error',

  UpdateUserIntegrator = '[Api] Update UserIntegrator',
  UpdateUserIntegratorSuccess = '[Api] Update UserIntegrator Success',
  UpdateUserIntegratorError = '[Api] Update UserIntegrator Error',

  DeleteUserIntegrator = '[Api] Delete UserIntegrator',
  DeleteUserIntegratorSuccess = '[Api] Delete UserIntegrator Success',
  DeleteUserIntegratorError = '[Api] Delete UserIntegrator Error',

  GetUserIntegratorIndex = '[Api] Get UserIntegrator',
  GetUserIntegratorIndexSuccess = '[Api] Get UserIntegrator Success',
  GetUserIntegratorIndexError = '[Api] Get UserIntegrator Error',

  GetEventsLogIndex = '[Api] Get Event log index',
  GetEventsLogIndexSuccess = '[Api] Get Event log index success',
  GetEventsLogIndexError = '[Api] Get Event log index error',

  setEventsLogSort = '[Api] Set events log sort params',

  clearEventLogSortParams = '[Api] clear events log sort params',

  ResendEvent = '[Api] Resend event webhook',
  ResendEventSuccess = '[Api] Resend event webhook success',

  ResetDefaults = '[Api] Reset initial store',


  // WebserviceConfiguration Headers
  ShowWebServiceConfigHeaders = '[Api] Show WebServiceConfigHeaders',
  ShowWebServiceConfigHeadersSuccess = '[Api] Show WebServiceConfigHeaders Success',
  ShowWebServiceConfigHeadersError = '[Api] Show WebServiceConfigHeaders Error',

  PutServiceConfigHeaders = '[Api] Put ServiceConfigHeaders',
  PutServiceConfigHeadersSuccess = '[Api] Put ServiceConfigHeaders Success',
  PutServiceConfigHeadersError = '[Api] Put ServiceConfigHeaders Error',

  // WebserviceConfiguration v3 (feature 020): paginacion local y error del modal.
  SetWebServicePageIndex = '[Api] Set WebServiceConfig Page Index',
  ClearWebServiceSaveError = '[Api] Clear WebServiceConfig Save Error',

  // Operaciones v3 (feature 023): paginacion local y error del modal.
  SetOperationsPageIndex = '[Api] Set Operations Page Index',
  SetOperationsPageSize = '[Api] Set Operations Page Size',
  ClearOperationSaveError = '[Api] Clear Operation Save Error',
}

export const setEventsLogSort = createAction(
  EApiActions.setEventsLogSort,
  props<{ payload: Partial<IWebhookEventQueryParams> }>()
);
export const clearEventLogSortParams = createAction(
  EApiActions.clearEventLogSortParams
);
export const GetEventsLogIndex = createAction(EApiActions.GetEventsLogIndex);
export const GetEventsLogIndexSuccess = createAction(
  EApiActions.GetEventsLogIndexSuccess,
  props<{ payload: IWebhookEvent[] }>()
);
export const GetEventsLogIndexError = createAction(
  EApiActions.GetEventsLogIndexError,
  props<{ payload: ServiceResponse }>()
);
export const ResendEvent = createAction(
  EApiActions.ResendEvent,
  props<{ payload: IWebhookEvent }>()
);

export const ResendEventSuccess = createAction(
  EApiActions.ResendEventSuccess,
  props<{ payload: ServiceResponse }>()
);

export const ResetDefaults = createAction(EApiActions.ResetDefaults);

export const CreateUserIntegrator = createAction(
  EApiActions.CreateUserIntegrator,
  props<{ payload: IUserIntegrator }>()
);
export const GetUserIntegratorIndex = createAction(
  EApiActions.GetUserIntegratorIndex
);

export const ShowUserIntegrator = createAction(
  EApiActions.ShowUserIntegrator,
  props<{ payload: { userId: number } }>()
);

export const ShowUserIntegratorSuccess = createAction(
  EApiActions.ShowUserIntegratorSuccess,
  props<{ payload: { client_user: IUserIntegratorResponse } }>()
);

export const UpdateUserIntegrator = createAction(
  EApiActions.UpdateUserIntegrator,
  props<{ payload: IUserIntegratorResponse }>()
);
export const DeleteUserIntegrator = createAction(
  EApiActions.DeleteUserIntegrator,
  props<{ payload?: { userId: number } }>()
);

export const CreateUserIntegratorSuccess = createAction(
  EApiActions.CreateUserIntegratorSuccess,
  props<{ payload: boolean }>()
);
export const UpdateUserIntegratorSuccess = createAction(
  EApiActions.UpdateUserIntegratorSuccess,
  props<{ payload: boolean }>()
);
export const DeleteUserIntegratorSuccess = createAction(
  EApiActions.DeleteUserIntegratorSuccess,
  props<{ payload: boolean }>()
);

export const DeleteUserIntegratorError = createAction(
  EApiActions.DeleteUserIntegratorError,
  props<{ payload: IUserIntegratorResponse }>()
);

export const GetUserIntegratorIndexError = createAction(
  EApiActions.GetUserIntegratorIndexError,
  props<{ payload: ServiceResponse }>()
);

export const GetUserIntegratorIndexSuccess = createAction(
  EApiActions.GetUserIntegratorIndexSuccess,
  props<{
    payload: {
      client_users: IUserIntegrator[];
    };
  }>()
);

export const CreateUserIntegratorError = createAction(
  EApiActions.CreateUserIntegratorError,
  props<{ payload: ServiceResponse }>()
);

export const ShowUserIntegratorError = createAction(
  EApiActions.ShowUserIntegratorError,
  props<{ payload: ServiceResponse }>()
);

export const UpdateUserIntegratorError = createAction(
  EApiActions.UpdateUserIntegratorError,
  props<{ payload: ServiceResponse }>()
);

export const ClearSelectedWebService = createAction(
  EApiActions.ClearSelectedWebService
);

export const ClearSelectedOperation = createAction(
  EApiActions.ClearSelectedOperation
);

export const ClearUserSelectedIntegrator = createAction(
  EApiActions.ClearUserSelectedIntegrator
);

export const setWebServiceConfigurationsSort = createAction(
  EApiActions.setWebServiceConfigurationsSort,
  props<{ payload: { sort: string } }>()
);
export const setOperationsSort = createAction(
  EApiActions.setOperationsSort,
  props<{ payload: { sort: string } }>()
);

export const setUserIntegratorSort = createAction(
  EApiActions.setUserIntegratorSort,
  props<{ payload: { sort: string } }>()
);

// acciones de entrada de datos webservice_configs
export const CreateWebServiceConfig = createAction(
  EApiActions.CreateWebServiceConfig,
  props<{ payload: IWebServiceConfigPayload }>()
);
/** Pide la lista completa de webhooks a la API v3; sin orden ni pagina (feature 020). */
export const GetWebServiceConfigIndex = createAction(
  EApiActions.GetWebServiceConfigIndex
);

export const ShowWebServiceConfig = createAction(
  EApiActions.ShowWebServiceConfig,
  props<{ payload: { webhookId: number } }>()
);

export const ShowWebServiceConfigHeaders = createAction(
  EApiActions.ShowWebServiceConfigHeaders,
  props<{ payload: { webhookId: number } }>()
);

/** Reemplaza un webhook en la API v3: el id va en la ruta y el cuerpo no lo lleva (feature 020). */
export const UpdateWebServiceConfig = createAction(
  EApiActions.UpdateWebServiceConfig,
  props<{ id: number; payload: IWebServiceConfigPayload }>()
);
export const DeleteWebServiceConfig = createAction(
  EApiActions.DeleteWebServiceConfig,
  props<{ payload?: { webhookId: number } }>()
);

// acciones de entrada de datos operaciones
/**
 * Crea una operacion en la API v3: nombre y webhook, sin id ni active (feature 023). requestId vuelve en el exito o
 * el error, para que cada guardado reciba solo su resultado.
 */
export const CreateOperation = createAction(
  EApiActions.CreateOperation,
  props<{ payload: IOperationPayload; requestId: number }>()
);
export const ShowOperation = createAction(
  EApiActions.ShowOperation,
  props<{ payload: { operationId: number } }>()
);

/**
 * Elimina una operacion en la API v3 (feature 023). requestId vuelve en el exito o el error, para que cada
 * eliminacion reciba solo su resultado.
 */
export const DeleteOperation = createAction(
  EApiActions.DeleteOperation,
  props<{ payload?: { operationId: number }; requestId: number }>()
);

// acciones de exito para los servicios
/** Lista completa de webhooks devuelta por la API v3, del mas reciente al mas antiguo. */
export const GetWebServiceConfigIndexSuccess = createAction(
  EApiActions.GetWebServiceConfigIndexSuccess,
  props<{ payload: IWebServiceConfig[] }>()
);

/** Webhook abierto en el modal de edicion, tal como lo devuelve la API v3. */
export const ShowWebServiceConfigSuccess = createAction(
  EApiActions.ShowWebServiceConfigSuccess,
  props<{
    payload: {
      webservice_config: IWebServiceConfig;
    };
  }>()
);

export const ShowWebServiceConfigHeadersSuccess = createAction(
  EApiActions.ShowWebServiceConfigHeadersSuccess,
  props<{
    payload: {
      webservice_config_headers: IWebHookConfigHeader[];
    };
  }>()
);

/** Detalle de la operacion abierta en Editar, leido de la API v3 (feature 023, FR-004). */
export const ShowOperationSuccess = createAction(
  EApiActions.ShowOperationSuccess,
  props<{
    payload: {
      operation: IOperationDetail;
    };
  }>()
);

export const CreateWebServiceConfiguSuccess = createAction(
  EApiActions.CreateWebServiceConfiguSuccess,
  props<{ payload: boolean }>()
);
export const UpdateWebServiceConfigSuccess = createAction(
  EApiActions.UpdateWebServiceConfigSuccess,
  props<{ payload: boolean }>()
);
export const DeleteWebServiceConfigSuccess = createAction(
  EApiActions.DeleteWebServiceConfigSuccess
);

// acciones de exito para los servicios
export const CreateOperationuSuccess = createAction(
  EApiActions.CreateOperationuSuccess,
  props<{ requestId: number }>()
);
export const UpdateOperationSuccess = createAction(
  EApiActions.UpdateOperationSuccess,
  props<{ requestId: number }>()
);
/** Sin requestId cuando viene de eliminar un webhook (feature 020), que tambien recarga Operaciones. */
export const DeleteOperationSuccess = createAction(
  EApiActions.DeleteOperationSuccess,
  props<{ requestId?: number }>()
);

// acciones para errores

export const GetWebServiceConfigIndexError = createAction(
  EApiActions.GetWebServiceConfigIndexError,
  props<{ payload: ServiceResponse }>()
);

export const CreateWebServiceConfigError = createAction(
  EApiActions.CreateWebServiceConfigError,
  props<{ payload: IWebServiceSaveError }>()
);

export const ShowWebServiceConfigError = createAction(
  EApiActions.ShowWebServiceConfigError,
  props<{ payload: ServiceResponse }>()
);

export const ShowWebServiceConfigHeadersError = createAction(
  EApiActions.ShowWebServiceConfigHeadersError,
  props<{ payload: ServiceResponse }>()
);

/**
 * No se pudo leer la operacion para Editar. httpStatus es el que deja BaseService.handleError: 404 si ya no
 * existe, 5xx, o 0 en un error de red; con el el contenedor decide el aviso (plan D8j, OD-1 y OD-2).
 */
export const ShowOperationError = createAction(
  EApiActions.ShowOperationError,
  props<{ payload: { message: string; httpStatus: number } }>()
);

export const UpdateWebServiceConfigError = createAction(
  EApiActions.UpdateWebServiceConfigError,
  props<{ payload: IWebServiceSaveError }>()
);

export const DeleteWebServiceConfigError = createAction(
  EApiActions.DeleteWebServiceConfigError,
  props<{ payload: IWebServiceSaveError }>()
);

export const GetOperationsIndexError = createAction(
  EApiActions.GetOperationsIndexError,
  props<{ payload: ServiceResponse }>()
);

/** Error de crear una operacion, ya convertido a lo que muestra el modal (feature 023). */
export const CreateOperationError = createAction(
  EApiActions.CreateOperationError,
  props<{ payload: IOperationSaveError; requestId: number }>()
);

/** Error de editar una operacion, ya convertido a lo que muestra el modal (feature 023). */
export const UpdateOperationError = createAction(
  EApiActions.UpdateOperationError,
  props<{ payload: IOperationSaveError; requestId: number }>()
);

export const DeleteOperationError = createAction(
  EApiActions.DeleteOperationError,
  props<{ payload: IOperationSaveError; requestId: number }>()
);

export const PutServiceConfigHeaders = createAction(
  EApiActions.PutServiceConfigHeaders,
  props<{ webhookId: number; payload: IWebHookConfigHeadersPayload }>()
);

export const PutServiceConfigHeadersSuccess = createAction(
  EApiActions.PutServiceConfigHeadersSuccess,
  props<{ payload: ServiceResponse }>()
);

export const PutServiceConfigHeadersError = createAction(
  EApiActions.PutServiceConfigHeadersError,
  props<{ payload: ServiceResponse }>()
);

// acciones de webhooks v3 (feature 020)

/** Pagina (base 1) de la tabla de webhooks; la paginacion es local, de 10 en 10. */
export const SetWebServicePageIndex = createAction(
  EApiActions.SetWebServicePageIndex,
  props<{ payload: { pageIndex: number } }>()
);

/** Limpia el error de crear o editar que muestra el modal. */
export const ClearWebServiceSaveError = createAction(
  EApiActions.ClearWebServiceSaveError
);

// acciones de operaciones v3 (feature 023)

/** Pide la lista completa de operaciones a la API v3; sin orden ni pagina, que se aplican en pantalla. */
export const GetOperationsIndex = createAction(EApiActions.GetOperationsIndex);

/** Lista completa de operaciones propias y compartidas devuelta por la API v3. */
export const GetOperationsIndexSuccess = createAction(
  EApiActions.GetOperationsIndexSuccess,
  props<{ payload: IOperationListItem[] }>()
);

/** Pagina (base 1) de la tabla de operaciones; la paginacion es local. */
export const SetOperationsPageIndex = createAction(
  EApiActions.SetOperationsPageIndex,
  props<{ payload: { pageIndex: number } }>()
);

/** Tamaño de pagina de la tabla de operaciones: 10, 20, 30 o 40. */
export const SetOperationsPageSize = createAction(
  EApiActions.SetOperationsPageSize,
  props<{ payload: { pageSize: number } }>()
);

/** Limpia el error de crear o editar una operacion que muestra el modal. */
export const ClearOperationSaveError = createAction(
  EApiActions.ClearOperationSaveError
);

/**
 * Reemplaza una operacion en la API v3: el id va en la ruta y el cuerpo no lo lleva (feature 023). requestId vuelve
 * en el exito o el error, para que cada guardado reciba solo su resultado.
 */
export const UpdateOperation = createAction(
  EApiActions.UpdateOperation,
  props<{ id: number; payload: IOperationPayload; requestId: number }>()
);
